import { createAsyncThunk } from "@reduxjs/toolkit";
import { companySliceName } from "..";
import server from "../../../../config/server";

export const getAppUsersAction = createAsyncThunk(`${companySliceName}/getAppUsers`, async (_, thunkAPI) => {
  try {
    const response = await server.get("/app/user/views", {}, {});
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const saveAppUserAction = createAsyncThunk(`${companySliceName}/saveAppUser`, async (data, thunkAPI) => {
  try {
    const response = await server.put("/app/user", data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const resetAppUserPasswordAction = createAsyncThunk(`${companySliceName}/resetAppUserPassword`, async (uuid, thunkAPI) => {
  try {
    const response = await server.put(`/app/user/password/reset?uuid=${uuid}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteAppUserAction = createAsyncThunk(`${companySliceName}/deleteAppUser`, async (uuid, thunkAPI) => {
  try {
    const response = await server.delete(`/app/user?uuid=${uuid}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
